import { Grid } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { FiCreditCard, FiFileText, FiLock, FiShield, FiZap } from "react-icons/fi";

import { VBabyColors } from "../../colors";
import TermsLabel from "../../components/TermsLabel";
import {
  Body,
  Card,
  EmotionPanel,
  IconCircle,
  PanelNote,
  PanelSubtitle,
  PanelTitle,
  PriceBox,
  PriceLabel,
  PriceValue,
  PrimaryButton,
  SecondaryButton,
  Shell,
  TermsLine,
} from "../../components/vbaby";
import { useExam } from "../../contexts/examContext";
import { formatPrice } from "../../utils/formatPrice";
import { buildSummary } from "./buildSummary";
import { WalletButton } from "./components/WalletButton";

export const PriceScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [exam] = useExam();
  const { form, setForm } = useOutletContext();

  const { contextLine, price } = buildSummary(exam, t);

  // Pix e boleto são só para quem tem CPF; o cartão é o único que aceita não morador.
  const goToCpfMethod = (path) => () => {
    if (!form.isBrazilResident) {
      setForm((prev) => ({ ...prev, isBrazilResident: true }));
    }

    navigate(path);
  };

  return (
    <Shell>
      <Card>
        <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }}>
          <EmotionPanel>
            <IconCircle aria-hidden="true">
              <FiLock size={22} />
            </IconCircle>
            <PanelTitle>{t("payment.summaryTitle")}</PanelTitle>
            <PanelSubtitle>{t("payment.summarySubtitle")}</PanelSubtitle>
            {contextLine && (
              <PanelSubtitle fontSize="12.5px" color="vbaby.onPanelMuted">
                {contextLine}
              </PanelSubtitle>
            )}
            <PanelNote>
              <FiShield aria-hidden="true" />
              {t("payment.secureImmediate")}
            </PanelNote>
          </EmotionPanel>

          <Body justifyContent="center">
            {price !== null && (
              <PriceBox>
                <PriceLabel>{t("payment.summarySingleValue")}</PriceLabel>
                <PriceValue>{formatPrice(price)}</PriceValue>
              </PriceBox>
            )}

            <WalletButton />

            <PrimaryButton
              type="button"
              onClick={goToCpfMethod("/checkout/pix")}
            >
              <FiZap aria-hidden="true" />
              {t("payment.pixNow")}
            </PrimaryButton>

            <Grid templateColumns="1fr 1fr" gap="10px">
              <SecondaryButton
                type="button"
                onClick={() => navigate("/checkout/card")}
              >
                <FiCreditCard aria-hidden="true" />
                {t("payment.creditCard")}
              </SecondaryButton>
              <SecondaryButton
                type="button"
                onClick={goToCpfMethod("/checkout/boleto")}
              >
                <FiFileText aria-hidden="true" />
                {t("payment.boleto")}
              </SecondaryButton>
            </Grid>

            <TermsLine>
              <TermsLabel
                label={t("payment.termsAgreement")}
                linkColor={VBabyColors.primaryDark}
              />
            </TermsLine>
          </Body>
        </Grid>
      </Card>
    </Shell>
  );
};
